// Captures a frame from the video element, scales it down if larger than maxDimension,
// then compresses it as JPEG trying quality levels from high to low until the result fits within maxBytes.
// Returns undefined if canvas context is unavailable.
export async function resizeImage(video: HTMLVideoElement, canvas: HTMLCanvasElement): Promise<File | undefined> {
    const maxDimension = 2048;
    const maxBytes = 2 * 1024 * 1024; // 2MB
    // Scale down only if the video exceeds maxDimension; never upscale (scale capped at 1)
    const scale = Math.min(1, maxDimension / Math.max(video.videoWidth, video.videoHeight));
    canvas.width = Math.round(video.videoWidth * scale);
    canvas.height = Math.round(video.videoHeight * scale);

    const ctx = canvas.getContext('2d');
    if (!ctx) {
        return undefined;
    }
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

    // Try decreasing quality levels and return the first blob that fits within maxBytes
    let imageQuality = 9;
    while (imageQuality >= 1) {
        const blob = await new Promise<Blob | null>((resolve) =>
            canvas.toBlob(resolve, 'image/jpeg', imageQuality / 10),
        );
        if (blob && blob.size <= maxBytes) {
            return new File([blob], `photo_${Date.now()}.jpg`, { type: 'image/jpeg' });
        }
        imageQuality--;
    }
    return undefined;
}
